/*
 *   File : detail.js
 *   Author : https://evoqins.com
 *   Description : catalog detail page
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import parse from 'html-react-parser';

//custom component
import { TextButton } from '../../../Component/Buttons';
import { Icon } from '../../../Component/Icon';
import Slider from 'react-slick';
// Import css files
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { APIService } from '../../../Service';
import { Loader } from '../../../Component/Others';
import { EmptyScreen } from '../../../Component/EmptyComponent';
import { ConfirmDeleteModal } from '../../../Component/Modal';
import { toast } from 'react-toastify';
import { Modal } from 'bootstrap';

const CATEGORY_TAB = [
    {
        id: 1,
        name: "Overview"
    },
    {
        id: 2,
        name: "Product Information"
    },
    {
        id: 3,
        name: "Features"
    },
    {
        id: 4,
        name: "Datasheets"
    }
];

const CatalogDetail = () => {

    const navigate = useNavigate();
    const { state } = useLocation();

    const [tabIndex, setTabIndex] = useState(0);
    const [detailData, setDetailData] = useState({});
    const [loader, setLoader] = useState(true);

    const [deleteResponse, setDeleteResponse] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [deleteLoader, setDeleteLoader] = useState(false);

    useEffect(() => {
        if (state !== null) {
            if (state.detail_tab) {
                setTabIndex(state.detail_tab);
            } else {
                setTabIndex(1);
            }
        } else {
            navigate("/manage-training");
        }
    }, [state]);

    useEffect(() => {
        if (state?.catalogue_id) {
            _getDetailData();
        } else {
            navigate("/manage-training");
        }
    }, [state?.catalogue_id]);

    useEffect(() => {
        window.scrollTo({
            top: 0, behavior: 'smooth' //scroll top
        });
    }, []);

    useEffect(() => {
        if (deleteModal === true) {
            const delete_modal = new Modal(document.getElementById('confirm-delete-modal'));
            delete_modal.show();
        }
    }, [deleteModal]);

    // handle tab change 
    const _handleTabChange = (id) => {
        navigate("/catalog/detail", {
            state: {
                ...state,
                detail_tab: id,
            }
        });
    };

    const _handleDownload = (download_url) => {
        const url = download_url;
        // const link = document.createElement('a');
        // link.href = url;
        // link.download = '';
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);


        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const data = "<ul>\n<li>test</li>\n<li>test</li>\n</ul>\n"
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };


    // API - Get detail data
    const _getDetailData = () => {
        let is_post = true;
        let url = 'CA/catalogue/detail';
        let data = {
            "catalogue_id": state?.catalogue_id
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setDetailData(response.data);
            } else {
                setDetailData({});
            }
            setLoader(false);
        });
    };

    // API - Delete catalogue 
    const _deleteCatalogue = () => {
        setDeleteLoader(true);
        let is_post = true;
        let url = 'CA/catalogue/delete';
        let data = {
            "catalogue_id": state?.catalogue_id
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setDeleteResponse(true);
            } else {
                setDeleteResponse(false);
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
            setDeleteLoader(false);
        });
    };

    const [categoryData, setCategoryData] = useState({});

    return (
        <section className='pb-5'>
            <div className={`e-bg-lavender-blush-light padding-12px-top padding-98px-bottom padding-52px-lr`}>
                <div className='e-display-flex justify-content-space-between'>
                    <div className='e-display-flex cursor-pointer'
                        onClick={() => navigate("/catalog", {
                            state: {
                                tab_index: state?.tab_index
                            }
                        })}>
                        <img src={require("../../../Assets/Image/CountryAdmin/arrow-left.svg").default}
                            draggable={false}
                            className='cursor-pointer'
                            alt='arrow'
                        />
                        <h1 className='ps-1 mb-0 e-primary-font-playfair e-font-24 line-height-32px e-text-rich-black e-font-weight-600'>
                            Product detail
                        </h1>
                    </div>
                    <div className={`${loader ? "pe-none opacity-75" : ""} e-inline-flex padding-56px-right gap-0-24px`}>
                        <TextButton name="Edit"
                            className="e-font-16"
                            onPress={() => {
                                navigate("/catalog/manage-product", {
                                    state: {
                                        editData: detailData
                                    }
                                })
                            }} />
                        <TextButton name="Delete"
                            className="e-text-lust e-font-16"
                            onPress={() => { setDeleteModal(true); }} />
                    </div>
                </div>
            </div>

            <div className='margin-neg-66px-top padding-52px-lr'>
                <div className='e-bg-white e-admin-box-shadow p-4 e-border-radius-16 pb-5 '>

                    {loader ?
                        <Loader className="min-h-50vh py-5 my-5 d-flex flex-column h-100 align-items-center justify-content-center" />
                        :
                        <>
                            <p className='mb-1 e-alt-font-noto-sans e-text-raisin-black e-font-14 e-font-weight-400 line-height-20px'>
                                {detailData.product_type}
                            </p>

                            <h3 className='mb-2 pb-4 pt-2 e-alt-font-noto-sans e-text-raisin-black e-font-20 e-font-weight-600 line-height-28px'>
                                {detailData.name} <span className='e-bg-periwinkle e-border-radius-20 padding-6px-lr e-alt-font-noto-sans e-text-raisin-black e-font-14 e-font-weight-400 line-height-20px'>
                                    {detailData.category}
                                </span>
                            </h3>

                            <div className='text-center e-bg-bright-gray-dark e-border-radius-16 overflow-hidden'>
                                {detailData?.product_images !== null && detailData?.product_images?.length !== 0 ?
                                    <Slider {...settings}>
                                        {detailData.product_images.map((image, index) => (
                                            <div key={index} className='d-flex justify-content-center '>
                                                <img src={image}
                                                    draggable={false}
                                                    className='h-324px object-fit-contain'
                                                    alt='thumbnail' />
                                            </div>

                                        ))}
                                    </Slider>
                                    :
                                    <div className='d-flex justify-content-center '>
                                        <img src={detailData.thumbnail_url}
                                            draggable={false}
                                            className='h-324px object-fit-contain'
                                            alt='thumbnail' />
                                    </div>
                                }
                            </div>

                            {/* category tab */}
                            <div className='padding-40px-top d-flex align-items-center gap-3 overflow-auto e-tab-scroll'>
                                <div className='d-flex gap-0-16 '>
                                    {CATEGORY_TAB.map((data, key) => (
                                        <div key={key} className={`${tabIndex === data.id ? 'e-bg-lust e-text-white border-transparent pe-none' : 'e-text-raisin-black e-border-1px-cool-grey'} transition e-border-radius-24 cursor-pointer w-max-content`}
                                            onClick={() => _handleTabChange(data.id)} >
                                            <p className='mb-0 px-4 padding-12px-tb e-alt-font-noto-sans e-font-14 e-font-weight-500 line-height-14px'>
                                                {data.name}
                                            </p>
                                        </div>
                                    ))}
                                </div>

                                <div className='d-flex gap-0-16 '>
                                    {detailData.categories.map((data, key) => (
                                        <div key={key} className={`${tabIndex === data.id ? 'e-bg-lust e-text-white border-transparent pe-none' : 'e-text-raisin-black e-border-1px-cool-grey'} transition e-border-radius-24 cursor-pointer w-max-content`}
                                            onClick={() => {
                                                _handleTabChange(data.id);
                                                setCategoryData(data);
                                            }} >
                                            <p className='mb-0 px-4 padding-12px-tb e-alt-font-noto-sans e-font-14 e-font-weight-500 line-height-14px'>
                                                {data.title}
                                            </p>
                                        </div>
                                    ))}
                                </div>

                            </div>

                            <div className='pt-4 mt-2'>
                                {/* <h4 className='mb-3 pb-4 e-text-rich-black e-alt-font-noto-sans e-font-20 e-font-weight-500 line-height-28px'>
                                    Added Informations
                                </h4> */}
                                {tabIndex === 1 ?
                                    <div>
                                        {detailData?.product_overview && detailData?.product_overview?.length !== 0 ?
                                            <ul className='ps-4 d-flex flex-column gap-3'>
                                                {detailData?.product_overview?.map((data, index) => (
                                                    <li key={index} className='mb-0 e-text-black-olive e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-20px'>
                                                        {data}
                                                    </li>
                                                ))}
                                            </ul>
                                            :
                                            <EmptyScreen message="No data found"
                                                className="py-5 my-5" />
                                        }

                                    </div>
                                    :
                                    tabIndex === 2 ?
                                        <div>
                                            <h4 className='mb-2 e-text-raisin-black e-alt-font-noto-sans e-font-16 e-font-weight-600 line-height-22px'>
                                                {detailData.product_title || "-"}
                                            </h4>
                                            <p className='mb-0 e-text-black-olive e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-20px'>
                                                {detailData.description || "-"}
                                            </p>

                                            <div className='pt-4'>
                                                <h4 className='mb-2 e-text-raisin-black e-alt-font-noto-sans e-font-16 e-font-weight-600 line-height-22px'>
                                                    {detailData.brochure || "-"}
                                                </h4>
                                                <p className='mb-0 e-text-black-olive e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-20px'>
                                                    {detailData.brochure_description || "-"}
                                                </p>

                                                {detailData.brochure_downloadable &&
                                                    <div className='d-flex align-items-center gap-1 mt-3 cursor-pointer text-decoration-hover-underline w-max-content'
                                                        onClick={() => _handleDownload(detailData.brochure_url)}>
                                                        <div className='e-bg-saffron padding-2px-all e-border-radius-4'>
                                                            <Icon icon="download-icon"
                                                                className="d-flex"
                                                                size={16} />
                                                        </div>
                                                        <TextButton name="Download Brocure"
                                                            className="text-decoration-none" />
                                                    </div>
                                                }
                                            </div>

                                            <a href='https://www.youtube.com/watch?v=loIf9-dB4aw' target='_blank' className='d-flex align-items-center gap-1 mt-4 cursor-pointer text-decoration-none text-decoration-hover-underline w-max-content'>
                                                <div >
                                                    <Icon icon="how-to-apply"
                                                        className="d-flex"
                                                        size={20} />
                                                </div>
                                                <TextButton name="How to apply"
                                                    className="text-decoration-none" />
                                            </a>
                                        </div>
                                        :
                                        tabIndex === 3 ?
                                            <div className='d-flex flex-column gap-3'>
                                                {detailData.features.length !== 0 ?
                                                    <>
                                                        {detailData.features.map((data, index) => (
                                                            <div key={index} className='d-flex align-items-start gap-2'>
                                                                <div>
                                                                    <img src={data.cover_image_url}
                                                                        draggable={false}
                                                                        width={24}
                                                                        height={24}
                                                                        alt='feature' />
                                                                </div>
                                                                <div>
                                                                    <h4 className='mb-2 e-text-raisin-black e-alt-font-noto-sans e-font-16 e-font-weight-500 line-height-22px'>
                                                                        {data.title}
                                                                    </h4>
                                                                    <p className='mb-0 e-text-dark-liver e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-16px'>
                                                                        {data.description}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </>
                                                    :
                                                    <EmptyScreen message="No data found"
                                                        className="py-5 my-5" />
                                                }

                                            </div>
                                            :
                                            tabIndex === 4 ?
                                                <>
                                                    {detailData?.datasheets?.length !== 0 ?
                                                        <div className='d-flex flex-column gap-3'>
                                                            {detailData?.datasheets.map((data, index) => (
                                                                <div key={index} className='e-bg-magnolia e-border-radius-16 px-3 padding-20px-tb d-flex align-items-center justify-content-between '>
                                                                    <div className='d-flex gap-2 align-items-start'>
                                                                        <img src={require("../../../Assets/Image/CountryAdmin/Catalog/sheet.svg").default}
                                                                            alt='sheet' />
                                                                        <p className='mb-0 e-text-raisin-black e-alt-font-noto-sans e-font-16 e-font-weight-500 line-height-22px'>
                                                                            {data.title}
                                                                        </p>
                                                                    </div>

                                                                    {data.enable_download === true &&
                                                                        <div>
                                                                            <Icon icon="download-icon"
                                                                                className="d-flex cursor-pointer"
                                                                                size={24}
                                                                                onPress={() => _handleDownload(data.file_url)} />
                                                                        </div>
                                                                    }
                                                                </div>
                                                            ))}
                                                        </div>
                                                        :
                                                        <EmptyScreen message="No data found"
                                                            className="py-5 my-5" />
                                                    }
                                                </>
                                                :
                                                Object.keys(categoryData).length !== 0 &&
                                                <div>
                                                    {categoryData.category_type === 1 ?
                                                        <>
                                                            <h4 className='mb-2 e-text-raisin-black e-alt-font-noto-sans e-font-16 e-font-weight-600 line-height-22px'>
                                                                {categoryData.category_name || "-"}
                                                            </h4>
                                                            <p className='mb-0 e-text-black-olive e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-20px'>
                                                                {categoryData.description || "-"}
                                                            </p>
                                                        </>
                                                        :
                                                        categoryData.category_type === 2 ?
                                                            <>
                                                                {categoryData.category_upload_type === 1 ?
                                                                    <div className='d-flex align-items-start gap-2'>
                                                                        <div>
                                                                            <img src={categoryData.file_url}
                                                                                draggable={false}
                                                                                width={24}
                                                                                height={24}
                                                                                alt='feature' />
                                                                        </div>
                                                                        <div>
                                                                            <h4 className='mb-2 e-text-raisin-black e-alt-font-noto-sans e-font-16 e-font-weight-500 line-height-22px'>
                                                                                {categoryData.category_name}
                                                                            </h4>
                                                                            <p className='mb-0 e-text-dark-liver e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-16px'>
                                                                                {categoryData.description}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    :
                                                                    <div className='e-bg-magnolia e-border-radius-16 px-3 padding-20px-tb text-center position-relative'>
                                                                        <div >
                                                                            <img src={categoryData.file_url}
                                                                                width={328}
                                                                                height={232}
                                                                                className='object-fit-contain'
                                                                                alt='file' />
                                                                        </div>

                                                                        {categoryData.enable_download === true &&
                                                                            <div className='position-absolute top-16px right-16px'>
                                                                                <Icon icon="download-icon"
                                                                                    className="d-flex cursor-pointer"
                                                                                    size={24}
                                                                                    onPress={() => _handleDownload(categoryData.file_url)} />
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                }
                                                            </>
                                                            :
                                                            categoryData.category_type === 3 ?
                                                                <a href={categoryData.redirection_link ?? "#"} target='_blank' className='d-flex align-items-center gap-1 cursor-pointer text-decoration-none text-decoration-hover-underline w-max-content'>
                                                                    <div >
                                                                        <Icon icon="how-to-apply"
                                                                            className="d-flex"
                                                                            size={20} />
                                                                    </div>
                                                                    <TextButton name={categoryData.category_name}
                                                                        className="text-decoration-none" />
                                                                </a>
                                                                :
                                                                null

                                                    }

                                                </div>
                                }
                            </div>
                        </>
                    }

                </div>
            </div>

            {deleteModal === true &&
                <ConfirmDeleteModal label="catalogue"
                    deleteId={state?.catalogue_id}
                    loader={deleteLoader}
                    response={deleteResponse}
                    delete={() => _deleteCatalogue()}
                    success={() => navigate("/catalog", {
                        state: {
                            tab_index: state?.tab_index
                        }
                    })}
                    handleClose={() => setDeleteModal(false)} />
            }
        </section >
    )
}

export default CatalogDetail;
